export const environment = {
  production: true,
  apiUrl: 'https://int-api.dynamix.co.pl'
};
